let _instance;
const ResourcesStorage = {};

function addItem(id, item) {
    this._map = this._map || {};
    this._map[id] = item;

    return item;
}

function addItems(items) {
    this._map = this._map || {};

    const ids = Object.keys(items);

    ids.forEach((id) => { this.add(id, items[id]); });

    return items;
}

function setItemNotLoaded(id) {
    this._map = this._map || {};
    if (typeof this._map[id] !== 'undefined') return this._map[id];

    this._map[id] = null;

    return null;
}

function getItem(id) {
    if (!this._map) return undefined;

    return this._map[id];
}

function getItemsMap() {
    return this._map || null;
}

function clearItem(id) {
    const map = this._map[id];

    delete this._map[id];

    return map;
}

const createStorage = () => {
    const stg = {};

    stg.add = addItem.bind(stg);
    stg.addItems = addItems.bind(stg);
    stg.setNotLoaded = setItemNotLoaded.bind(stg);
    stg.getItem = getItem.bind(stg);
    stg.getItemsMap = getItemsMap.bind(stg);
    stg.clearItem = clearItem.bind(stg);

    return stg;
};

ResourcesStorage.instance = () => {
    if (_instance) return _instance;
    _instance = createStorage();

    return _instance;
};

ResourcesStorage.destroy = () => {
    const instance = _instance;

    _instance = null;

    return instance;
};

ResourcesStorage.getIsolatedInstance = () => createStorage();

export default ResourcesStorage;
export { ResourcesStorage };
